import { REVIEWS_REQUEST, REVIEWS_SUCCESS, REVIEWS_FAILURE } from '../Action-types';

const initialState = {
  items: [], // aquí van las reseñas
  loading: false,
  error: null,
};

const reviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case REVIEWS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case REVIEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
      };

    case REVIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
export default reviewReducer;
